<div class="d-flex flex-column position-relative" style="width: 95%; z-index: 110;">
    <div class="search-filter d-flex cursor">
        <input type="search" *ngIf="!selectedItem" (click)="openDropListVehicle()" [placeholder]="labelSearchFilter" [formControl]="searchTerm"
        aria-describedby="addon-wrapping" aria-label="Rechercher">
        <input type="text" *ngIf="selectedItem" (click)="removeSelected()" value="{{selectedItem.immatriculation}}"
            aria-describedby="basic-addon2">
        <span class="input-group-text filter-button" *ngIf="!isOpenFilterForm" id="basic-addon2" (click)="openModal()">
            <i-bs name="filter"></i-bs>
        </span>
        <span class="input-group-text filter-button" *ngIf="isOpenFilterForm" id="basic-addon2" (click)="closeDropDown()">
            <i-bs name="x-circle"></i-bs>
        </span>
    </div>
    <div class="row drop-down" *ngIf="isOpenFilterForm">
        <ng-container [ngTemplateOutlet]="template"></ng-container>
    </div>
</div>
<div class="modal-bg-click" *ngIf="isOpenFilterForm" (click)="closeDropDown()">
</div>

<ng-template #template>
    <div class="modal-content-drop">
        <ng-content></ng-content>
    </div>
</ng-template>